// This module contains resable functions composed from Ramda
import * as R from 'ramda';

export const sortAsLowerCaseByNameProp = R.sortBy(R.compose(R.toLower, R.prop('name')));
